module.exports = __webpack_public_path__ + "img/dalbabob.93ebd21f.png";